<template>
  <div>
    <v-breadcrumbs
      :items="breadcrumbs"
      class="grey lighten-2 white--text"
    ></v-breadcrumbs>
    <div class="pa-4 grey lighten-4">
      <div class="d-flex align-center justify-space-between mb-4">
        <p class="subtitle-1 ma-0">
          Escolha uma empresa abaixo para editar ou excluir.
        </p>
        <v-btn
          v-if="empresaParceiraCriar"
          small
          depressed
          color="fmq_gray"
          dark
          to="/empresa-parceira-criar"
          >Nova Empresa</v-btn
        >
      </div>
      <EmpresasParceirasTabela
        :headers="headers"
        :empresas="empresas"
        :total="totalEmpresas"
        :pageText="pageText"
        :loading="loading"
        :pageNumber="page"
        @handleFilter="filter"
        @excluir="excluirModal"
      >
        <template v-slot:nome>
          <v-text-field
            v-model="formData.nome"
            placeholder="Digite o nome"
            solo
            flat
            dense
            :hide-details="true"
            @input="page = 1;getEmpresasParceiras(formData)"
            :clearable="true"
          >
          </v-text-field>
        </template>

        <template v-slot:cnpj>
          <v-text-field
            v-model="formData.cnpj"
            placeholder="Digite o CNPJ"
            solo
            flat
            dense
            :hide-details="true"
            :clearable="true"
          >
          </v-text-field>
        </template>

        <template v-slot:razaoSocial>
          <v-text-field
            v-model="formData.razaoSocial"
            placeholder="Digite a Razão Social"
            solo
            flat
            dense
            :hide-details="true"
            :clearable="true"
            @input="page = 1;getEmpresasParceiras(formData)"
          >
          </v-text-field>
        </template>

        <template v-slot:cidade>
          <v-text-field
            v-model="formData.cidade"
            placeholder="Digite a Cidade"
            solo
            flat
            dense
            :hide-details="true"
            :clearable="true"
            @input="page = 1;getEmpresasParceiras(formData)"
          >
          </v-text-field>
        </template>

        <template v-slot:ativo>
          <v-autocomplete
            v-model="formData.ativo"
            :items="listStatus"
            hide-no-data
            hide-selected
            item-text="label"
            item-value="value"
            placeholder="Digite o status"
            solo
            flat
            dense
            :hide-details="true"
            :clearable="true"
            @input="page = 1;getEmpresasParceiras(formData)"
          ></v-autocomplete>
        </template>

        <template v-slot:id>
          <div class="d-flex justify-start">
            <v-btn class="mr-2" outlined x-small fab color="red" @click="clear">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-btn outlined x-small fab color="blue" @click="search">
              <v-icon>mdi-magnify</v-icon>
            </v-btn>
          </div>
        </template>
      </EmpresasParceirasTabela>
    </div>
    <AlertConfirmation
      :dialog="dialog"
      :dialogMessage="dialogMessage"
      @close="dialog = false"
      @accept="excluir"
    />
    <AlertSuccess
      :dialog="success"
      dialogMessage="Empresa excluida com sucesso"
      @close="
        getEmpresasParceiras(formData, page);
        success = false;
      "
    />
    <AlertError :alertError="error" :messageError="messageError" />
  </div>
</template>

<script>
import EmpresasParceirasTabela from "@/components/empresas-parceiras/EmpresasParceirasTabela.vue";
import {
  buscarEmpresaParceira,
  excluirEmpresaParceira,
} from "@/services/empresas-parceiras";
export default {
  name: "EmpresasParceiras",
  components: {
    EmpresasParceirasTabela,
  },
    beforeCreate() {
    if(this.$store.state.user.data.tipo === "Representante") {
      this.$router.push({path: '/'})
    }
  },
  data: () => ({
    breadcrumbs: [
      {
        text: "Empresas Parceiras",
        disabled: true,
        to: "EmpresasParceiras",
      },
    ],
    headers: [
      { text: "Nome da Empresa", value: "nome" },
      { text: "CNPJ", value: "cnpj" },
      { text: "Razão Social", value: "razaoSocial" },
      { text: "Cidade", value: "cidade" },
      { text: "Status", value: "ativo" },
      { text: "Ações", value: "id", sortable: false },
    ],
    empresas: [],
    totalEmpresas: null,
    pageText: null,
    loading: false,
    formData: {
      orderBy: null,
      orderSorted: null,
      perPage: 15,
      nome: null,
      cnpj: null,
      razaoSocial: null,
      cidade: null,
      ativo: null,
    },
    page: 1,
    listStatus: [
      {
        value: "1",
        label: "ATIVO",
      },
      {
        value: "0",
        label: "INATIVO",
      },
    ],
    dialog: false,
    dialogMessage: null,
    empresaId: null,
    error: false,
    success: false,
    messageError: null,
  }),
  created() {
    if (this.$store.state.empresaParceiraSearch.length) {
      this.formData = { ...this.$store.state.empresaParceiraSearch[0] };
    }
    this.getEmpresasParceiras(this.formData, this.page);
  },
  methods: {
    async getEmpresasParceiras(payload, page) {
      this.empresas = [];
      this.$store.dispatch("setEmpresaParceiraSearch", payload);
      try {
        this.loading = true;
        const resp = await buscarEmpresaParceira(payload, page);
        this.empresas = resp.data.data;
        this.totalEmpresas = resp.data.total;
        this.pageText = `${resp.data.from}-${resp.data.to} de ${resp.data.total}`;
      } catch (e) {
        this.loading = false;
      } finally {
        this.loading = false;
      }
    },
    clear() {
      this.$store.dispatch("setEmpresaParceiraSearch", {});
      this.formData.nome = null;
      this.formData.cnpj = null;
      this.formData.razaoSocial = null;
      this.formData.cidade = null;
      this.formData.ativo = null;
      this.page = 1;
      this.getEmpresasParceiras(this.formData, this.page);
    },
    search() {
      this.page = 1;
      this.getEmpresasParceiras(this.formData, this.page);
    },
    filter(event) {
      this.$store.dispatch("setEmpresaParceiraSearch", this.formData);
      if (event.orderBy === "razaoSocial") {
        this.formData.orderBy = "razao_social";
      } else {
        this.formData.orderBy = event.orderBy;
      }
      this.formData.orderSorted = event.orderSorted;
      this.formData.perPage = event.perPage;
      this.page = event.page;
      this.getEmpresasParceiras(this.formData, this.page);
    },
    async excluir() {
      this.error = false;
      this.sucess = false;
      try {
        await excluirEmpresaParceira(this.empresaId).then(() => {
          this.dialog = false;
          this.success = true;
        });
      } catch (e) {
        this.dialog = false;
        this.error = true;
        this.messageError = e.response.data.message;
      }
    },
    excluirModal(item) {
      this.dialogMessage = `Tem certeza que deseja excluir ${item.nome}?`;
      this.dialog = true;
      this.empresaId = item.id;
    },
  },
  computed: {
    empresaParceiraCriar() {
      return this.$store.state.user.data.permissoes.includes(
        "empresaParceira.criar"
      );
    },
  },
};
</script>

<style></style>
